import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import InspectionItem from './inspection-item';
import InspectionItemDetail from './inspection-item-detail';
import InspectionItemUpdate from './inspection-item-update';
import InspectionItemDeleteDialog from './inspection-item-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={InspectionItemUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={InspectionItemUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={InspectionItemDetail} />
      <ErrorBoundaryRoute path={match.url} component={InspectionItem} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={InspectionItemDeleteDialog} />
  </>
);

export default Routes;
